import React, { useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const socket = io(process.env.REACT_APP_URL);

function Chatbox({room}) {
  const [message, setMessage] = useState('');
  const [chat, setChat] = useState([]);

useEffect(() => {
  if (!room) return;
  socket.emit('join room', room);
  socket.on('chat_history', (messages) => {
    setChat(messages);
  });

  socket.on('receive_message', (msg) => {
    setChat((prev) => [...prev, msg]);
  });

  return () => {
    socket.off('chat_history');
    socket.off('receive_message');
        if (room) {
        socket.emit('leave room', room);
    }
  };
}, [room]);

  const sendMessage = () => {
  if (message.trim()) {
    const msgData = {
      text: message,
      sender: socket.id,
      time: new Date().toLocaleTimeString(),
      room: room
    };
    socket.emit('send_message', msgData);  
    setMessage('');
  }
};

  return (
    <div style={{ border: '1px solid #ccc', padding: 16, width: 300 }}>
      <h3>Chatroom</h3>
       
    <div style={{ height: 150, overflowY: 'auto', marginBottom: 10 }}>
      {chat.map((msg, index) => (
        <div key={index}>
          <strong>{msg.sender === socket.id ? 'You' : msg.sender}:</strong> {msg.text}
        </div>
      ))}
    </div>
      <input
        type="text"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
        style={{ width: '100%', marginBottom: 8 }}
        placeholder="Type a message..."
      />
      <button onClick={sendMessage} style={{ width: '100%' }}>Send</button>
    </div>
  );
}

export default Chatbox;